<template>
	<div class="container">
		<div class="content">
			<h2 class="mb_15">{{ $t('merchant.title6') }}</h2>
			<div class="card mb_0">
				<h3 class="title mb_15">{{ $t('merchant.menu_2.menu7') }}</h3>
				<div class="otp">
					<security-info />
					<div class="certification_otp_explanation mb_30">
						<div class="gray_back">
							<p>
								{{ $t('merchant.otp.text1') }}
							</p>
							<p>
								{{ $t('merchant.otp.text2') }}
							</p>
						</div>
						<span class="arrow"></span>
						<div class="gray_back">
							<p>
								{{ $t('merchant.otp.text3') }} JM3E642DGFZHIL2IGVJWES3RJVDWSM3S
								{{ $t('merchant.otp.text4') }}
							</p>
						</div>
						<span class="arrow"></span>
						<div class="gray_back">
							<p>
								{{ $t('merchant.otp.text5') }}
							</p>
						</div>
						<span class="arrow"></span>
						<div class="gray_back">
							<p>
								{{ $t('merchant.otp.text6') }}
							</p>
						</div>
					</div>
					<div class="certification_otp">
						<p class="qr_img mb_30">
							<img src="../../../assets/images/qr_sample.jpg" alt="" />
						</p>
						<p class="mb_10">{{ $t('merchant.otp.text7') }}</p>
						<input
							type="text"
							value="1312123134564df"
							class="readonly mb_20"
							readonly
						/>
						<p class="mb_10">
							{{ $t('merchant.otp.text8') }}
						</p>
						<input
							type="text"
							class="mb_10"
							:placeholder="$t('merchant.otp.text9')"
						/>
						<button class="button_bg_red">{{ $t('button.otp') }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="info_area">
			<div>
				<p>{{ $t('banner2.text1') }}</p>
				<span>10:00-19:00 {{ $t('banner2.text2') }}</span>
			</div>
			<div class="partition">
				<p>{{ $t('banner2.text3') }}</p>
				<span>{{ $t('banner2.text4') }} {{ $t('banner2.text5') }}</span>
			</div>
			<div>
				<p>{{ $t('banner2.text6') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text7') }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Merchant/Certification/SecurityInfo';
export default {
	name: 'Otp.m',
	components: { SecurityInfo },
};
</script>
